var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSearchIcon = function SvgSearchIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 19,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m18.317 17.07-2.553-2.711A8.602 8.602 0 0 0 17.86 8.74C17.86 3.92 13.853 0 8.93 0 4.007 0 0 3.92 0 8.74s4.006 8.74 8.93 8.74c1.848 0 3.61-.546 5.115-1.582l2.593 2.752c.221.226.52.35.84.35.301 0 .588-.113.806-.318a1.124 1.124 0 0 0 .033-1.612ZM8.93 2.28c3.639 0 6.6 2.898 6.6 6.46s-2.961 6.46-6.6 6.46c-3.64 0-6.6-2.898-6.6-6.46s2.96-6.46 6.6-6.46Z",
    fill: "#141414"
  })));
};
export default SvgSearchIcon;